import React from 'react'
import Styling from '../../styling'

export default function KPI(props) {
  const {label, value, className=""} = props
  return (
    <div className={`text-center ${className}`}>
        <p className={`${Styling.sizes.xs.default} text-primary-800 mb-1`}>{label}</p>
        <p className={`${Styling.sizes.xs.strong}`}>{value}</p>
    </div>
  )
}
